export const DollarBillsIcon = () => (
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2523_13377"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="15"
      y="33"
      width="98"
      height="62"
    >
      <path d="M112.68 33.22H15.3301V94.78H112.68V33.22Z" fill="white" />
    </mask>
    <g mask="url(#mask0_2523_13377)">
      <path
        d="M82.1005 38.7H29.4605C29.4205 43.48 25.5805 47.35 20.8105 47.44V63.39C23.8905 63.43 26.5805 65.07 28.1305 67.5V55.91C28.1305 50.84 32.2405 46.73 37.3105 46.73H87.4106C84.3106 45.38 82.1305 42.31 82.0905 38.71L82.1105 38.69L82.1005 38.7Z"
        fill="#F470BD"
      />
      <path
        d="M20.8101 63.38V47.44C25.5701 47.35 29.4101 43.47 29.4601 38.7H82.1001C82.1401 42.29 84.3001 45.37 87.4201 46.72H96.2901V38.79C96.2901 35.71 93.7801 33.22 90.7201 33.22H20.9001C17.8401 33.22 15.3301 35.73 15.3301 38.79V72.1C15.3301 75.18 17.8401 77.67 20.9001 77.67H28.1301V67.48C26.5801 65.05 23.8901 63.41 20.8101 63.37V63.38Z"
        fill="#EE399E"
      />
      <path
        d="M112.67 55.89V89.2C112.67 89.98 112.51 90.7 112.24 91.36C111.39 93.36 109.41 94.77 107.1 94.77H37.3005C34.9905 94.77 33.0105 93.36 32.1605 91.36C31.8705 90.69 31.7305 89.95 31.7305 89.2V55.89C31.7305 54.74 32.0905 53.67 32.6905 52.77C33.7005 51.29 35.3905 50.32 37.3005 50.32H107.08C109.01 50.32 110.7 51.29 111.69 52.77C112.28 53.65 112.65 54.73 112.65 55.89H112.67Z"
        fill="white"
      />
      <path
        d="M98.5 55.81H45.86C45.82 60.59 41.98 64.46 37.21 64.55V80.5C42.02 80.57 45.9 84.48 45.9 89.32H98.52C98.52 84.51 102.38 80.59 107.17 80.5V64.55C102.37 64.48 98.52 60.6 98.48 55.81H98.5ZM72.2 83.39C65.93 83.39 60.84 78.31 60.84 72.03C60.84 65.75 65.92 60.67 72.2 60.67C78.48 60.67 83.56 65.75 83.56 72.03C83.56 78.31 78.48 83.39 72.2 83.39Z"
        fill="#F470BD"
      />
      <path
        d="M111.72 52.77C110.71 51.29 109.02 50.32 107.11 50.32H37.3005C35.3705 50.32 33.6805 51.29 32.6905 52.77C32.1005 53.65 31.7305 54.73 31.7305 55.89V89.2C31.7305 89.98 31.8905 90.7 32.1605 91.36C33.0105 93.36 34.9905 94.77 37.3005 94.77H107.08C109.39 94.77 111.37 93.36 112.22 91.36C112.51 90.69 112.65 89.95 112.65 89.2V55.89C112.65 54.74 112.29 53.67 111.69 52.77H111.71H111.72ZM107.19 80.49C102.39 80.58 98.5405 84.49 98.5405 89.31H45.9205C45.9205 84.48 42.0405 80.57 37.2305 80.49V64.54C41.9905 64.45 45.8305 60.57 45.8805 55.8H98.5205C98.5605 60.6 102.43 64.47 107.21 64.54V80.49H107.19Z"
        fill="#EE399E"
      />
      <path
        d="M72.1998 83.37C78.4698 83.37 83.5598 78.29 83.5598 72.01C83.5598 65.73 78.4798 60.65 72.1998 60.65C65.9198 60.65 60.8398 65.73 60.8398 72.01C60.8398 78.29 65.9198 83.37 72.1998 83.37Z"
        fill="#EE399E"
      />
    </g>
  </svg>
);
